import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Timeline from "@/components/landing/Timeline";
import AutomatedSystem from "@/components/landing/AutomatedSystem";
import Benefits from "@/components/landing/Benefits";
import Simulator from "@/components/landing/Simulator";
import FAQSection from "@/components/landing/FAQSection";
import Footer from "@/components/landing/Footer";

export default function NortonEmpower() {
  return (
    <div className="min-h-screen bg-background text-white font-body overflow-x-hidden" data-testid="norton-empower-page">
      <Header />
      <main>
        <Hero />
        <Timeline />
        <AutomatedSystem />
        <Benefits />
        <Simulator />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}
